var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('settings.general.languages')))]),_c('div',{staticClass:"bc-form-grid"},[_c('GeneralSetting',{attrs:{"data-key":"locale","label":_vm.$t('settings.general.page_language'),"list-translation-key":"settings.general.locales","value-ref":_vm.valueRef}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }